import React, { memo, useCallback } from 'react'

import { Icon, Search as SearchIcon, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

const searchIconSize = { height: '16px', width: '16px' }
const leadIcon = <Icon notSpaced svgComponent={SearchIcon} color="dark" size={searchIconSize} />

function Search({ value = '', onChange = NOOP, placeholder = 'Search' }) {
  const handleInputChange = useCallback(
    event => onChange(event.target.value),
    [onChange],
  )

  return (
    <TextInput
      id="community-gallery-search"
      isPilot
      size="medium"
      value={value}
      onChange={handleInputChange}
      placeholder={placeholder}
      leadIcon={leadIcon}
      wrapperClassName="filter-search"
      textInputClassName="filter-search__input"
      className="filter-search__field"
    />
  )
}

Search.propTypes = {
  value: string,
  onChange: func,
  placeholder: string,
}

export default memo(Search)
